import {IRule, IRuleset, ISystemRole} from "../../index";
import {ObjectTypeId} from "../../constants";
import {getObjectType} from "../../util/misc";
import {global, lm} from "../../appContext";
import {memoryStore} from "../../util/memorystore";
import {nsRuleset} from "../ruleset/nsRuleset";
import {getHash, setRouteHash} from "../../constants/RouteDefinitions";
export namespace nsSystem {

    export function getWizardUrl(window: boolean = false): string {
        const hash = getHash('wizardpermissions', {
            orgnr: global.login.selectedOrganizationId(),
        }, true) ?? '';
        return (window ? 'win.html' : '') + hash;
    }

    export function createRulesetWithRuleForObjectPermissionSystemRole(obj: ISystemRole) {
        const routeData = memoryStore.get('routeData');
        const rule: IRule = nsRuleset.generateRule({
            argumentoperator: 'Har verdi',
            attribute: `[OBJECTPERMISSION.SYSTEMROLE;Name;Id;${obj.id}]`,
        })
        const ruleset: IRuleset = nsRuleset.generateRuleset({
            companyid: global.login.selectedOrganizationId() ?? '',
            name: lm.t(`((has permission)): ${obj.id} - ${obj.name}`) ?? '',
            objecttype: getObjectType(ObjectTypeId.User),
            rules: [rule],
        })
        routeData(ruleset);
        setRouteHash('createruleset');
    }

}
